import * as React from 'react';
import { Grid, Typography } from '@material-ui/core';
import HourPicker from '../../../ui-components/HourPicker/HourPicker';
import { openingDetail } from '../../../model/room';
import { day } from '../../../model/subscription';

interface IProps {
    classes: any;
    day: day;
    value: openingDetail;
    onchange: (value: openingDetail) => any;
    key: string;
    disabled?: boolean;
}

const dayIsDisabled = (p: openingDetail) : boolean => {
    // var m = subscription.monthToBuy
    // var a = subscription.accessToBuy;
    // console.log("----t-i-m-e------------------------x-x-x-x-x-x-x----------------------");
    // console.log(p.openingTime);
    // console.log(p.closingTime);
    if (p === undefined) {
        // console.log("----t-i-m-e------------------------x-x-x-x-x-x-x-----------u-n-d-e-f-i-n-e-d------------");
        return true;
    }
    var inizio = p.openingTime.hours * 60 + p.openingTime.minutes;
    var fine = p.closingTime.hours * 60 + p.closingTime.minutes;
    // setSelectedDays({ ...selectedDays, [day]: openingDetails });
    // setSubscription({ ...subscription, subscriptionRules: selectedDays});
    // setSubscription({ ...subscription, subscriptionType: item.value, monthToBuy: 0, accessToBuy: 0  });
    return ((fine - inizio) <= 0);
}
const dayDurata = (p: openingDetail) : string => {
    // console.log("----t-i-m-e------------------------x-x-x-x-x-x-x----------------------");
    // console.log(p.openingTime);
    // console.log(p.closingTime);
    if (p === undefined) {
        return '';
    }
    var inizio = p.openingTime.hours * 60 + p.openingTime.minutes;
    var fine = p.closingTime.hours * 60 + p.closingTime.minutes;
    if ((fine - inizio) > 0) {
        var num = (fine - inizio);
        var hours = (num / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        // return num + " minutes = " + rhours + " hour(s) and " + rminutes + " minute(s).";
        if (rminutes > 0) {
            return " " + rhours + " ore e " + rminutes + "";    
        }
        return " " + rhours + " ore";
    }
    return '';
}

export const DayRow = (props: IProps) => {
    return (<Grid container className={dayIsDisabled(props.value) ? props.classes.dayIsDisabled : props.classes.dayIsEnabled}>
        <Grid item sm={3} className={props.classes.dayRowLabel}>
            <Typography>{props.day.name}</Typography>
        </Grid>
        <Grid item sm={3}>
            <HourPicker disabled={props.disabled}
                // className={props.classes.dayElement}
                // label="Orario di inizio"
                onChange={(h, m) => props.onchange({ ...props.value, openingTime: { hours: h, minutes: m } })}
                value={props.value?.openingTime} />
        </Grid>
        <Grid item sm={3}>
            <HourPicker disabled={props.disabled}
                // className={props.classes.dayElement}
                // label="Orario di fine"
                onChange={(h, m) => props.onchange({ ...props.value, closingTime: { hours: h, minutes: m } })}
                value={props.value?.closingTime} />
        </Grid>
        <Grid item sm={3} className={props.classes.dayRowLabel}>
            <Typography>{dayDurata(props.value)}</Typography>
        </Grid>
    </Grid>)
}